import { useCallback as e } from "react";
import t from "intl-messageformat";
//#region src/translations/t-helpers.ts
var n = (e, t, n) => (r, i) => {
	if (r === void 0) return "";
	let a = t(r);
	if (n && (r = n(r)), !a) return console.warn(`Can't find namespace. Make sure you pass all used namespaces in the getBaseServerSideProps. Some troubles with "${r}"`), "";
	for (let t of a) {
		let n = e(r, {
			ns: t,
			...i
		});
		if (n && n !== r) return n;
	}
	return r;
}, r = (e, r, i) => (a, o, s) => {
	let c = n(e, r, i);
	try {
		let e = c(a, s);
		if (!e) return "";
		let n = new t(e).format(o);
		return Array.isArray(n) ? n.join("") : n;
	} catch (e) {
		return console.error(`tICU formatting error for key "${a}":`, e), "";
	}
}, i = ({ useTranslation: t, defaultNamespaces: i, namespaceMapper: a, assetKeyMapper: o }) => function(s = []) {
	let { t: c, ...l } = t([...i, ...s]);
	return {
		t: e(n(c, a, o), [c]),
		tICU: e(r(c, a, o), [c]),
		...l
	};
};
//#endregion
export { n as getTFuncWithNamespace, r as getTICUFuncWithNamespace, i as getUseLocoTranslation };
